import { render } from "./PendingRequests.vue?vue&type=template&id=34ba70b6&scoped=true"
import script from "./PendingRequests.vue?vue&type=script&lang=js"
export * from "./PendingRequests.vue?vue&type=script&lang=js"

import "./PendingRequests.vue?vue&type=style&index=0&id=34ba70b6&scoped=true&lang=css"

import exportComponent from "../../../../app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34ba70b6"]])

export default __exports__